// extracted by mini-css-extract-plugin
export default {"progress":"styles_progress__xaQdV","form":"styles_form__1Z7Ni","agreement":"styles_agreement__47EPM","resend":"styles_resend__QW1mA"};